module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// /codebuild/output/src2645790472/src/~/core-js/library/modules/_add-to-unscopables.js
// module id = cq/B
// module chunks = 6